import { useSearchParams } from 'react-router-dom';
import { ChatLeftSidebar } from './components/ChatLeftSidebar';
import { SalesChatSidebar } from './components/SalesChatSidebar';
import { ChatInterface } from './ChatsInterface';
import { getSalesContext } from 'app/store/dataUtils';

function ChatsPage() {
	const [searchParams] = useSearchParams();
	const sidebarEnabled = searchParams.get('sidebarEnabled') === 'true';
	const salesContext = getSalesContext();
	const showSalesSidebar = !!salesContext && salesContext.shipments.length > 1;

	return (
		<div className="flex font-['Inter']  h-full">
			{showSalesSidebar && <SalesChatSidebar />}
			{!salesContext && sidebarEnabled && <ChatLeftSidebar />}
			<ChatInterface />
		</div>
	);
}

export default ChatsPage;
